import { createApp } from 'vue';
import App from './App.vue';

export default function init() {
  const elements = document.querySelectorAll('#elasticSearch');

  if (elements.length > 0) {
    elements.forEach((element) => {
      const app = createApp(App, { ...element.dataset });

      app.mount(element);
    });
  }
}
